export default __webpack_public_path__ + "static/media/order_3.abe95566.svg";